import { gql } from "@apollo/client";

export const resolvePostcodeQuery = gql`
query ResolvePostcode($postcode: String!) {
  resolvePostcode(postcode: $postcode) {
    message
    result {
      postcode
      lat
      lng
      source
    }
  }
}
`;
